import { Icon } from 'semantic-ui-react';

export const GenderIcon = ({ anatomy }: { anatomy: string | undefined }) => {
  if (!anatomy) return null;

  return (
    <span style={{ marginLeft: 8 }}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {anatomy === 'male' ? (
        <Icon name="mars" size="large" />
      ) : anatomy === 'female' ? (
        <Icon name="venus" size="large" />
      ) : (
        <Icon name="venus mars" size="large" />
      )}
    </span>
  );
};
